import React, { useContext, useState } from "react";
import { ButtonProps, CommandBarButton, ensure } from "sprint-common-web";

import { MergeMovieVersionsRequest } from "../../../api/MergeMovieVersionsRequest";
import { useAssetsManageMovieApi } from "../../../api/useAssetsManageMovieApi";
import { MovieVersionListingContext } from "../context/MovieVersionListingContext";
import { MovieVersionListingItem } from "../MovieVersionListingItem";
import { MergeMovieVersionsConfirmationModal } from "./MergeMovieVersionsConfirmationModal";

export const MergeMovieVersionsCommandBarButton: React.FunctionComponent<ButtonProps> = (props: ButtonProps) => {
    const { versionsToMerge, movieDetails, setMovieVersionAsMerged, clearVersionsToMerge } = useContext(
        MovieVersionListingContext
    );
    const { mergeVersions } = useAssetsManageMovieApi();
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const isMergeButtonDisabled = () => {
        return versionsToMerge.length < 2;
    };

    const [target, orphan] = versionsToMerge;

    const handleMergeButtonClick = async (): Promise<void> => {
        ensure(movieDetails);

        setIsLoading(true);

        await mergeVersions(movieDetails.id, createMergeRequest(target, orphan));
        setMovieVersionAsMerged(orphan.id, target.id);

        closeModal();
        clearVersionsToMerge();
        setIsLoading(false);
    };

    const confirmationButtonDisabled = props.disabled || isMergeButtonDisabled();

    return (
        <>
            <CommandBarButton onClick={openModal} text="Merge" icon="Merge" disabled={confirmationButtonDisabled} />
            <MergeMovieVersionsConfirmationModal
                movieId={movieDetails.id}
                targetVersion={target}
                orphanedVersion={orphan}
                isOpen={isModalOpen}
                isConfirmationDisabled={isLoading}
                onConfirm={handleMergeButtonClick}
                onDismiss={closeModal}
            />
        </>
    );
};

const createMergeRequest = (
    target: MovieVersionListingItem,
    orphan: MovieVersionListingItem
): MergeMovieVersionsRequest => {
    return {
        targetVersionId: target.id,
        orphanedVersionId: orphan.id
    };
};
